(function () {
  function log(){ try{ console.log('[privacy]', ...arguments); }catch(e){} }

  function wait(tries){
    tries = tries || 0;
    if (window.Shopify && typeof Shopify.loadFeatures === 'function') {
      log('loading consent-tracking-api');
      Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function(err){
        if (err){ log('failed', err); return; }
        log('Consent API loaded');
        document.dispatchEvent(new CustomEvent('consentApiReady'));
      });
      return;
    }
    if (tries < 30) return setTimeout(function(){ wait(tries+1); }, 150);
    log('ERROR: Shopify.loadFeatures never appeared — ensure this file is included AFTER {{ content_for_header }}');
  }
  wait();

  // OPTIONAL: only if using Shopify’s own cookie banner
  document.addEventListener('consentApiReady', function(){
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (cp && cp.shouldShowBanner && cp.shouldShowBanner()) {
        if (typeof privacyBanner !== 'undefined' && privacyBanner.loadBanner) {
          privacyBanner.loadBanner({
            storefrontAccessToken: 'YOUR_STOREFRONT_API_TOKEN',
            storefrontRootDomain: 'newatersofteners.co.uk',
            checkoutRootDomain: 'checkout.newatersofteners.co.uk',
            locale: 'en',
            country: 'gb'
          });
        } else {
          log('privacyBanner script not present (ok if you use a third-party CMP)');
        }
      }
    } catch(e){ console.warn('[privacy] banner init error', e); }
  });
})();
